import { Directive } from "@angular/core";
import { MatDatepickerInput } from "@angular/material/datepicker";

@Directive({
  selector: '[disableFutureDates]',
  standalone: true
})
export class DisableFutureDatesDirective {
   
    constructor(private element: MatDatepickerInput<Date>) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        this.element.max = today;
    }

}